import { IsString, ValidateNested } from 'class-validator';
import { PageResponseVm } from 'api/core/page-response.vm';
import { Type } from 'class-transformer';

export class PickedItemVm {
    @IsString()
    pickingId: string;

    @IsString()
    itemId: string;

    @IsString()
    locationId: string;

    @IsString()
    batch?: string;

    @IsString()
    serialNumber?: string;

    @IsString()
    productSku: string;

    @IsString()
    productName: string;

    @IsString()
    orderItemId: string;

    @IsString()
    orderItemExternalId: string;

    @IsString()
    quantity: number;

    @IsString()
    containerProductId?: string;

    @IsString()
    containerProductName?: string;

    @IsString()
    containerProductSku?: string;

    @IsString()
    containerSerialNumber?: string;

    @IsString()
    logisticSupportId: string;

    @IsString()
    pickerName: string;

    @IsString()
    integrationError?: string;
}

export class GetPickedItemsVm extends PageResponseVm<PickedItemVm, string> {
    @IsString()
    nextOffset: string;

    @Type(() => PickedItemVm)
    @ValidateNested({ each: true })
    objects: PickedItemVm[];
}
